/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum PncCreateActionEnum {
    CREATE = 'CREATE',
    CREATE_AND_SOLVE = 'CREATE_AND_SOLVE'
}

